import React from "react";

export default function AccountIcon({ className = '' }) {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_822_1183)">
                <path d="M3.78223 0V8.7278H6.25485V16.0009L12.219 6.25473H8.72777L12.219 0H3.78223Z" fill="#4F6E90" />
            </g>
            <defs>
                <clipPath id="clip0_822_1183">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
